import { fileChangeListener, nl2br } from '../../general/functions';
import { initExportScripts } from './_export';
import { actionButtonListener, buttonExportListener, editModalListener, filterTableListener } from './_listener';
import { databaseTable, importValidation, initEventSelect2 } from './_setup';

let asideContainer = document.getElementById('kt_aside_right_content'),
  header = KTUtil.find(asideContainer, '.offcanvas-header'),
  content = KTUtil.find(asideContainer, '.offcanvas-content'),
  wrapper = KTUtil.find(asideContainer, '.offcanvas-wrapper'),
  footer = KTUtil.find(asideContainer, '.offcanvas-footer'),
  _asideToggleObj = new KTOffcanvas(asideContainer, {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_aside_right_content_close',
    toggleBy: 'kt_aside_right_content_toggle',
  });

initEventSelect2();

filterTableListener();
actionButtonListener();
editModalListener();

buttonExportListener();

initExportScripts();

/**
 * Import excel data
 */

fileChangeListener($('#importFiles'));

$('#form_import').on('submit', function (e) {
  e.preventDefault();

  KTApp.block('#modalImport', {
    opacity: 0.1,
    state: 'primary',
  });

  let curBtn = $(this).find('button[type="submit"]');

  curBtn.attr('disabled', true);

  importValidation.validate().then(function (status) {
    if (status == 'Valid') {
      $('#form_import')[0].submit();
    } else {
      curBtn.attr('disabled', false);
      KTApp.unblock('#modalImport');
    }
  });
});

$('#filterCard [name="eventNameFilter"]').attr('data-placeholder', 'Please select an event');

if ($('#databaseTable').length) {
  databaseTable.on('datatable-on-ajax-fail', function (e, o) {
    Swal.fire({
      title: 'Network problem detected',
      message: 'Slow connection detected, please try again later',
      icon: 'error',
      showCancelButton: false,
      confirmButtonText: 'Close',
    });

    KTApp.unblock('#databaseTable');
    KTApp.unblock('#filterCard');
  });

  databaseTable.on('datatable-on-goto-page', function (e, o) {
    KTApp.block('#databaseTable', {
      opacity: 0.1,
      state: 'primary',
    });

    KTApp.block('#filterCard', {
      opacity: 0.1,
      state: 'primary',
    });
  });

  databaseTable.on('datatable-on-update-perpage', function (e, o) {
    KTApp.block('#databaseTable', {
      opacity: 0.1,
      state: 'primary',
    });

    KTApp.block('#filterCard', {
      opacity: 0.1,
      state: 'primary',
    });
  });

  databaseTable.on('datatable-on-ajax-done', function (e, o) {
    KTApp.unblock('#databaseTable');
    KTApp.unblock('#filterCard');
  });
}

$(document).on('click', '.btn-readmore', function (e) {
  e.preventDefault();

  let id = $(this).data('id'),
    type = $(this).data('type'),
    title = $(this).data('title'),
    label = $(this).data('label'),
    content = $(this).data('content'),
    isEncode = $(this).data('encode');
  var htmlRegex = /<\/?[a-z][\s\S]*>/i;
  var newlinePattern = /\r?\n/;

  $('body').addClass('overflow-y-hidden');
  $('#aside_right_title').text(title);
  $('#aside_right_label').text(label);

  if (!id) {
    if (isEncode == 'yes') {
      content = decodeURIComponent(content);
      $('#aside_right_notes').html(htmlRegex.test(content) ? nl2br(content) : newlinePattern.test(content) ? nl2br(content) : content);
    } else {
      // $('#aside_right_notes').html(nl2br(content))
      $('#aside_right_notes').html(htmlRegex.test(content) ? nl2br(content) : newlinePattern.test(content) ? nl2br(content) : content);
    }
  }
  _asideToggleObj.show();
});

$('#kt_aside_right_content_close').on('click', function (e) {
  $('body').removeClass('overflow-y-hidden');
});
$(document).on('click', '.offcanvas-overlay', function (e) {
  $('#kt_aside_right_content_close').trigger('click');
});

$(document)
  .on('mouseenter', '.togglePopover', function () {
    $(this).popover({ container: 'body' }).popover('show');
  })
  .on('mouseleave', '.togglePopover', function () {
    $(this).popover('hide');
  });